import {Action} from "@ngrx/store";

export const LOAD_HOSTING_SETTINGS: string = '[info] Load HostingSettings';
export const LOAD_HOSTING_SETTINGS_SUCCESS: string = '[info] Load HostingSettings Success';
export const LOAD_HOSTING_SETTINGS_FAIL: string = '[info] Load HostingSettings Fail';

export class LoadHostingSettings implements Action {
  readonly type: string = LOAD_HOSTING_SETTINGS;
  constructor(public payload: number) {}
}

export class LoadHostingSettingsSuccess implements Action {

  readonly type: string = LOAD_HOSTING_SETTINGS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[websiteId: number]: any},
  }) {}

}

export class LoadHostingSettingsFail implements Action {

  readonly type: string = LOAD_HOSTING_SETTINGS_FAIL;
  constructor(public payload: string) {}

}


export type HostingSettingsAction = LoadHostingSettings | LoadHostingSettingsSuccess | LoadHostingSettingsFail;
